import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Typography, Box, Paper } from '@mui/material';
import { useStyles } from 'tss-react';
import { formatAmount } from 'src/utils/formatAmout';

const ReviewData = ({ values }) => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  return (
    <Paper className={classes.container}>
      <Box
        sx={{ display: 'flex', flexDirection: 'column', gap: 2, padding: 2 }}
      >
        <Box
          sx={{ display: 'flex', alignItems: 'center', gap: 1, marginTop: 2 }}
        >
          <Typography variant="h6" sx={{ fontSize: 16, fontWeight: 500 }}>
            {t('EARLY_TERMINATION.TERMINATION_DESCRIPTION_PART_ONE', {
              contractFolio: values.folio,
              client: values.clientName,
              equipmentType: values.equipmentType,
              brand: values.equipmentBrand,
              model: values.equipmentModel
            })}
            <span style={{ fontWeight: 700 }}>
              {t('EARLY_TERMINATION.TERMINATION_DESCRIPTION_PART_TWO', {
                rent: formatAmount(values.rent)
              })}
            </span>
            <span style={{ fontSize: 16, fontWeight: 500 }}>
              {t('EARLY_TERMINATION.TERMINATION_DESCRIPTION_PART_THREE')}
            </span>
          </Typography>
        </Box>

        <Box
          sx={{ display: 'flex', alignItems: 'center', gap: 1, marginTop: 2 }}
        >
          <Typography sx={{ fontSize: 16, fontWeight: 500 }}>
            {t('EARLY_TERMINATION.TERMINATION_RELEASE_AND_NO_RELEASE_PART_ONE')}
            <span style={{ fontSize: 16, fontWeight: 800 }}>
              {values.forgiveDebt || values.balance === 0
                ? t('EARLY_TERMINATION.TERMINATION_RELEASE')
                : t('EARLY_TERMINATION.TERMINATION_NO_RELEASE')}
            </span>
            <span style={{ fontSize: 16, fontWeight: 500 }}>
              {t(
                'EARLY_TERMINATION.TERMINATION_RELEASE_AND_NO_RELEASE_PART_TWO'
              )}
            </span>
          </Typography>
        </Box>
        <Typography
          className={classes.confirmation}
          sx={{ fontSize: 16, fontWeight: 500 }}
        >
          {t('EARLY_TERMINATION.TERMINATION_CONFIRM')}
        </Typography>
      </Box>
    </Paper>
  );
};

ReviewData.propTypes = {
  values: PropTypes.object.isRequired
};

export default ReviewData;
